import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["$css", "variant", "header", "links", "children"],
    _excluded2 = ["text"];
import React from 'react';
import { css } from 'styled-components';
import LinkOrButton from '../../LinkOrButton';
import { Div, Span } from '../../Styled';
import { flex, focus, hover, SPACINGS } from '../../../styling';
import { Error, InfoCircle } from '../../svg';
import { COLORS, TYPOGRAPHY } from '../../../themes';

var InlineAlert = function InlineAlert(_ref) {
  var $css = _ref.$css,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      header = _ref.header,
      links = _ref.links,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = function () {
    switch (variant) {
      case 'warning':
        return {
          color: COLORS.NOTICE_300,
          bgColor: COLORS.NOTICE_100,
          Icon: InfoCircle,
          iconColor: COLORS.NOTICE_600
        };

      case 'error':
        return {
          color: COLORS.NEGATIVE_300,
          bgColor: COLORS.NEGATIVE_100,
          Icon: Error,
          iconColor: COLORS.NEGATIVE_400
        };

      default:
        return {
          color: COLORS.PRIMARY_300,
          bgColor: COLORS.PRIMARY_100,
          Icon: InfoCircle,
          iconColor: COLORS.PRIMARY_500
        };
    }
  }(),
      color = _ref2.color,
      bgColor = _ref2.bgColor,
      Icon = _ref2.Icon,
      iconColor = _ref2.iconColor;

  return /*#__PURE__*/React.createElement(Div, _extends({
    $css: css(["user-select:none;display:flex;background-color:", ";border:1px solid ", ";border-radius:4px;", ""], COLORS.WHITE, color, $css)
  }, rest), /*#__PURE__*/React.createElement(Div, {
    $css: css(["padding:20px ", "px;background:", ";border-radius:4px 0 0 4px;"], SPACINGS.L, bgColor)
  }, /*#__PURE__*/React.createElement(Icon, {
    color: iconColor
  })), /*#__PURE__*/React.createElement(Div, {
    $css: css(["width:100%;", " padding:20px ", "px ", "px ", "px;"], flex('flex-start', 'center', 'row', 'wrap'), SPACINGS.XL, SPACINGS.M, SPACINGS.L)
  }, /*#__PURE__*/React.createElement(Div, null, header && /*#__PURE__*/React.createElement(Span, {
    $css: css(["display:inline-block;flex:0 0 auto;margin:0 ", "px ", "px 0;", ""], SPACINGS.S, SPACINGS.S, TYPOGRAPHY.S_BOLD)
  }, header), /*#__PURE__*/React.createElement(Span, {
    $css: css(["display:inline-block;margin-bottom:", "px;", ";color:", ";"], SPACINGS.S, TYPOGRAPHY.S, COLORS.NEUTRAL_500)
  }, children)), links && /*#__PURE__*/React.createElement(Div, {
    $css: css(["margin:-10px 0 -2px auto;padding-left:", "px;"], SPACINGS.S)
  }, links.map(function (_ref3, index) {
    var text = _ref3.text,
        rest = _objectWithoutProperties(_ref3, _excluded2);

    return /*#__PURE__*/React.createElement(LinkOrButton, _extends({
      key: index,
      $css: css(["display:inline-block;padding:10px ", "px;border-radius:4px;text-decoration:none;:not(:last-child){margin-right:", "px;}", " ", ""], SPACINGS.M, SPACINGS.S, hover('background', COLORS.WHITE, COLORS.PRIMARY_100, COLORS.PRIMARY_200), focus(css(["box-sizing:border-box;box-shadow:0 0 0 4px ", ";"], COLORS.PRIMARY_500))),
      visuallyHiddenText: text
    }, rest), /*#__PURE__*/React.createElement(Div, {
      $css: css(["", " ", ""], TYPOGRAPHY.S_SEMIBOLD, hover('color', COLORS.NEUTRAL_600, COLORS.PRIMARY_600, COLORS.PRIMARY_600))
    }, text));
  }))));
};

export default InlineAlert;